import moment from "moment";

/**
 * Formats a given date into a specified format.
 *
 * @param {any} date - The date to be formatted. This can be a Date object, string, or any value that Moment.js can parse.
 * @param {any} dateFormat - The format string to use for formatting the date. This should be a valid Moment.js format string.
 * @returns {string} - The formatted date as a string.
 *
 * @example
 * // Format a date object
 * const formattedDate = formatDate(new Date(), 'MMMM D, YYYY');
 * console.log(formattedDate); // Output: "July 13, 2024"
 *
 * @example
 * // Format a date string
 * const formattedDate = formatDate('2024-07-13', 'MMMM D, YYYY');
 * console.log(formattedDate); // Output: "July 13, 2024"
 */
export const formatDate = (date: any, dateFromat: any) => {
  return moment(date).format(dateFromat);
};

/**
 * Formats a given Unix timestamp into a specified date format.
 *
 * @param {any} timestamp - The Unix timestamp to be formatted. This should be a value that Moment.js can parse as a Unix timestamp.
 * @param {any} dateFormat - The format string to use for formatting the timestamp. This should be a valid Moment.js format string.
 * @returns {string} - The formatted date as a string.
 *
 * @example
 * // Format a Unix timestamp
 * const formattedDate = formatTimeStamp(1721145600, 'MMMM D, YYYY');
 * console.log(formattedDate); // Output: "July 13, 2024"
 *
 * @example
 * // Format a Unix timestamp with a different format
 * const formattedDate = formatTimeStamp(1721145600, 'YYYY-MM-DD');
 * console.log(formattedDate); // Output: "2024-07-13"
 */
export const formatTimeStamp = (timestamp: any, dateFromat: any) => {
  return moment.unix(timestamp).format(dateFromat);
};

export const formatDateTime = (timestamp: any, dateFromat: any) => {
  return moment(timestamp).format(dateFromat);
};

export const formatDateToISO = (date: Date) => {
  return moment(date).format("YYYY-MM-DD HH:mm:ss");
};
